import { isOfflineDataEnabled } from 'owa-offline-sync-feature-flags';
import {
    lazyGetOfflineTimeZones,
    lazyGetOfflineTimeZoneOffsets,
} from 'owa-offline-timezones/lib/lazyIndex';

function getTimeZones() {
    if (!isOfflineDataEnabled()) {
        return Promise.resolve(undefined);
    }
    return lazyGetOfflineTimeZones.importAndExecute();
}

function getTimeZoneOffsets() {
    if (!isOfflineDataEnabled()) {
        return Promise.resolve(undefined);
    }
    return lazyGetOfflineTimeZoneOffsets.importAndExecute();
}

export const getTimeZoneOverrides = {
    getTimeZones,
    getTimeZoneOffsets,
};
